import axios from 'axios';

// Scheduled irrigation events

export const retrieveAllBlockScheduledIrrigationEvents = async () => axios.get('/api/schedule/irrigation/');
export const retrieveBlockScheduledIrrigationEvents = async (blockId) => axios.get(`/api/schedule/irrigation/block/${blockId}/`);

export const createScheduledIrrigationEvent = async (scheduledIrrigationEvent) => {
  return axios.post('/api/schedule/irrigation/new/', scheduledIrrigationEvent);
};

export const retrieveScheduledIrrigationEvent = async (id) => (
  axios.get(`api/schedule/irrigation/${id}/`)
);

export const updateScheduledIrrigationEvent = async (data) => (
  axios.put(`api/schedule/irrigation/${data.id}/`, data)
);

export const patchScheduledIrrigationEvent = async (data) => (
  axios.patch(`api/schedule/irrigation/${data.id}/`, data)
);

export const deleteScheduledIrrigationEvent = async (id) => (
  axios.delete(`api/schedule/irrigation/${id}/`)
);

// Rendered irrigation events

export const retrieveBlockRenderedIrrigationEvents = async ({ blockId, dateStart, dateEnd }) => {
  const query = `?dateStart=${dateStart.toISOString()}&dateEnd=${dateEnd.toISOString()}`;
  return axios.get(`/api/schedule/irrigation/block/${blockId}/rendered/${query}`);
};

// Event edits

export const createBlockScheduledIrrigationEventEdit = async (scheduledIrrigationEventEdit) => {
  return axios.post('/api/schedule/irrigation/edit/new/', scheduledIrrigationEventEdit);
};

export const retrieveBlockScheduledIrrigationEventEdit = async (eventEditId) => {
  return axios.get(`/api/schedule/irrigation/edit/${eventEditId}/`);
};

export const retrieveBlockScheduledIrrigationEventEditByIndex = async ({ eventId, eventIndex }) => {
  return axios.get(`/api/schedule/irrigation/${eventId}/edit/${eventIndex}/`);
};

export const updateBlockScheduledIrrigationEventEdit = async (scheduledIrrigationEventEdit) => {
  const { id: eventEditId } = scheduledIrrigationEventEdit;
  return axios.put(`/api/schedule/irrigation/edit/${eventEditId}/`, scheduledIrrigationEventEdit);
};

export const deleteBlockScheduledIrrigationEventEdit = async (eventEditId) => {
  return axios.delete(`/api/schedule/irrigation/edit/${eventEditId}/`);
};

export const retrieveBlockWaterUsageData = async ({ blockIds, dateStart, dateEnd }) => {
  return axios.get(`/api/block/water-usage/?blockIds=${blockIds.join(',')}&dateStart=${dateStart}&dateEnd=${dateEnd}`);
};

export const emailWaterUsageData = async (emailContent) => {
  return axios.post('/api/block/water-usage/email/', emailContent);
};
